import { Col, Row } from 'react-bootstrap';
import GenerationTimingsChart from './GenerationTimingsChart';

const GenerationTimings = ({ monitoringBlock, g2Model, g3Model }) => {
  const dates = g3Model.SDATA || [];
  const sprayData = monitoringBlock.alcm_spray_data;
  const trapCatchData = g2Model.trap_catch;
  const gddAccumulationData = g3Model.GDD_ACCUMULATION || [];

  return (
    <Row>
      <Col>
        <GenerationTimingsChart
          dates={dates}
          sprayData={sprayData}
          trapCatchData={trapCatchData}
          gddAccumulationData={gddAccumulationData}
        />
      </Col>
    </Row>
  );
};

export default GenerationTimings;

